/**
 * 获取列表界面的搜索项
 */
export function getSearchData(flag) {
    let data = []
    switch (flag) {
        case "exam":
            // 考试
            data = [{
                    title: "主题",
                    type: "input",
                    value: "",
                    key: "name"
                },
                {
                    title: "考试时间",
                    type: "time-range",
                    value: [],
                    key: "time"
                },
            ]
            break;
        case "read":
            // 阅卷
            data = [{
                    title: "主题",
                    type: "input",
                    value: "",
                    key: "name"
                },
                {
                    title: "考试时间",
                    type: "time-range",
                    value: [],
                    key: "time"
                },
            ]
            break;
        case "subject":
            // 科目
            data = [{
                title: "科目名称",
                type: "input",
                value: "",
                key: "name",
            }, ]
            break

        default:
            break;
    }
    return data
}
/**
 * 获取界面搜索框旁边的按钮
 * @param {*} flag  标识哪个界面
 */
export function getTopButArray(flag) {
    let data = []
    switch (flag) {
        case "exam":
            // 试卷列表
            data = [
                { name: "新增考试", active: "create", icon: "el-icon-plus" },
                { name: "考试导入", active: "import", icon: "el-icon-upload" },
            ]
            break;
        case "read_student":
            // 待阅卷学生列表
            data = [
                { name: "成绩导出", active: "export", icon: "el-icon-upload" },
            ]
            break;
        case "subject":
            // 科目列表
            data = [
                { name: "新增科目", active: "create", icon: "el-icon-plus" },
            ]
            break;
        default:
            break;
    }
    return data
}
/**
 * 获取题库列表表头数据
 */
export function getQuestionTableMenu() {
    return [
        { name: "考试主题", key: "name", isStar: false },
        { name: "考试时间", key: "time", isStar: false },
        { name: "状态", key: "status", isStar: false },
        { name: "专业", key: "professional", isStar: false },
        { name: "试卷", key: "testParperName", isStar: false },
        { name: "考试部门", key: "department", isStar: false },
        { name: "参考人数", key: "personNum", isStar: false },
        { name: "监考老师", key: "teacher", isStar: false },
        { name: "关联任务", key: "associatedTask", isStar: false, isPrimary: true },
    ]
}

/**
 * 获取待阅卷学生列表表头数据
 */
export function getQuestionStudentTableMenu() {
    return [
        { name: "考试主题", key: "name", isStar: false },
        { name: "学员姓名", key: "userName", isStar: false },
        { name: "考试状态", key: "status", isStar: false, isColor: true },
        { name: "交卷时间", key: "subTime", isStar: false },
        { name: "试卷总题数", key: "num", isStar: false },
        { name: "正确题数", key: "successNum", isStar: false },
        { name: "错误题数", key: "errorNum", isStar: false },
        { name: "考试分数", key: "grade", isStar: false },
    ]
}

/**
 * 模拟题库列表数据
 */
export function initTableData() {
    return [
        { id: "111", examTheme: "2023年3月份月考", examTime: "2023-3-15 14:00:00", examType: "待发布", examDuration: "120", examinationRoom: "23号", teacher: "张三", department: "市场一部", associatedTask: "上岗培训" }
    ]
}

/**
 * 获取表格操作按钮
 * @param {*} flag  表示当前为哪个界面的
 */
export function getTableBUttonList(flag) {
    switch (flag) {
        case "exam":
            // 考试
            return [
                { text: "发布", active: "issue_exam" },
                { text: "启用B卷", active: "start_plan_b" },
                { text: "考试归档", active: "end_exam" },
                { text: "编辑", active: "edit_exam" },
                { text: "删除", active: "delete_exam" },
            ]
            break;
        case "read":
            // 阅卷
            return [
                { text: "阅卷", active: "read_paper" },
            ]
            break;

        default:
            break;
    }
}

/**
 * 获取系统排号的模拟数据
 */
export function getAutomaticNumbering() {
    return [
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
        { icon: "", name: "张安", studentNum: "202205140001", admissionTicket: "202205140001", department: "市场一部", seat: "001", },
    ]
}

export function getExamEditPageData() {
    return [
        { title: "考试主题", type: "input", key: "name", value: "", isNotNull: true, ishe: true },
        { title: "考试时间", type: "time", key: "examTime", value: "", isNotNull: true, ishe: false },
        { title: "考试时长", type: "input", key: "examDuration", value: "", isNotNull: true, ishe: false, tip: "分钟" },
        { title: "考试部门", type: "selects", key: "department", value: [], option: [], isNotNull: true, ishe: false },
        { title: "考试专业", type: "selects", key: "professional", value: [], option: [], isNotNull: false, ishe: false },
        // {
        //     title: "考试方式",
        //     type: "radio",
        //     key: "model",
        //     value: "0",
        //     option: [
        //         { label: "线上考试", value: "0" },
        //         { label: "线下考试", value: "1" },
        //     ],
        //     isNotNull: false,
        //     ishe: false
        // },
        // { title: "考场号", type: "input", key: "examinationRoom", value: "", isNotNull: false, ishe: false },
        { title: "主试卷", type: "select", key: "testPaperId", value: "", option: [], isNotNull: true, ishe: true },
        // { title: "备用试卷", type: "selects", key: "spare", value: [], option: [], isNotNull: false, ishe: true },
        { title: "阅卷老师", type: "selects", key: "readOver", value: [], option: [], isNotNull: true, ishe: true },
        { title: "监考老师", type: "selects", key: "teacher", value: [], option: [], isNotNull: false, ishe: true },
    ]
}